export interface IMicrositeRecipientCoachLogEntry {
    id: number,
    micrositeRecipientId: number,
    logDateTime: string,
    updatedDateTime: string,
    displayDate: string,
    actionType: number,
    content: string,
    isPinned: boolean,
    createdByUserId?: number,
    updatedByUserId?:number
}